export default {
  buttons: {
    apply: "@txt_100_buttons_apply",
    cancel: "@txt_17_cancel",
    dismiss: "@txt_5_close",
    minimize: "@txt_100_minimize",
    unminimize: "@txt_100_unminimize",
    add_waypoint: "@txt_5_add_a_destination"
  },
  distance: {
    value: "{distance, number, distance} {unit}",
    unit: {
      miles: "@txt_2_mi"
    }
  },
  search: {
    title: "@txt_1_search",
    placeholder: "@txt_30_enter_a_location",
    enter_location: "@txt_30_enter_a_location",
    recent_searches: "@txt_100_recent_searches",
    suggestions: "@txt_100_search_suggestions",
    geolocation: "@txt_30_use_my_location",
    help: {
      inactive: "@txt_1_search",
      clear: "@txt_1_clear"
    }
  },
  filters: {
    title: "@txt_16_filters",
    more: "@txt_100_morefilters",
    less: "@txt_100_lessfilters",
    group: {
      more: "@txt_100_more",
      less: "@txt_100_less"
    },
    amenities: {
      title: "@txt_4_service_amenities"
    },
    fuels: {
      title: "@txt_3_fuel_types"
    }
  },
  directions: {
    title: "@txt_5_route_planner",
    help: {
      add_waypoint: "@txt_100_directions_help_add_waypoint",
      reverse: "@txt_100_directions_help_reverse",
      sort_waypoint: "@txt_100_directions_help_sort_waypoint",
      remove: "@txt_100_directions_help_remove"
    },
    placeholder: {
      origin: "@txt_100_placeholder_origin",
      destination: "@txt_30_enter_a_location",
      waypoint: "@txt_30_enter_a_location"
    },
    route: {
      title: "@txt_5_route_options",
      title_avoid: "@txt_100_directions_route_title_avoid",
      avoid_tolls: "@txt_5_avoid_toll_roads",
      avoid_highways: "@txt_5_avoid_motorways",
      avoid_ferries: "@txt_100_directions_route_avoid_ferries",
      title_corridor: "@txt_5_distance_from_route_to_service_stations"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# @txt_100_directions_travel_time_week} other {# @txt_100_directions_travel_time_weeks}}
{days, plural, =0 {} =1 {# @txt_30_day} other {# @txt_30_days}}
{hours, plural, =0 {} =1 {# @txt_100_directions_travel_time_hour} other {# @txt_100_directions_travel_time_hours}}
{minutes, plural, =0 {} =1 {# @txt_30_min} other {# @txt_30_mins}}\
`,
    button: "@txt_5_search",
    error: "@txt_100_directions_error"
  },
  action_panel: {
    back_to_results: "@txt_100_info_window_back_to_results"
  },
  locations: {
    title: "@txt_11_locations",
    closed_temporarily: "@txt_100_locations_closed_temporarily",
    distance: "{distance, number, distance} {unit}",
    distance_from: "{distance, number, distance} {unit} @txt_13_from {place}",
    description: "{visible, select, true {@txt_100_locations_hide} false {@txt_100_locations_show} }"
  },
  info_window: {
    back_to_results: "@txt_100_info_window_back_to_results",
    title: "@txt_13_site_details",
    location_id: "@txt_32_site_id",
    website: "@txt_100_info_window_website",
    services: "@txt_4_service_amenities",
    nearby: "@txt_14_nearby",
    directions: "@txt_100_info_window_directions",
    mobile: {
      telephone: "@txt_31_tel"
    },
    opening_hours: {
      title: "@txt_13_open_close_hours",
      mon: "@txt_33_mon",
      tue: "@txt_33_tue",
      wed: "@txt_33_wed",
      thu: "@txt_33_thu",
      fri: "@txt_33_fri",
      sat: "@txt_33_sat",
      sun: "@txt_33_sun",
      open_twentyfourhours: "@txt_33_open_24_hours",
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      available: "@txt_100_info_window_fuels_available",
      not_available: "@txt_100_info_window_fuels_not_available",
      price: "{price, number, fuelPrice}",
      disclaimer: "@txt_100_short_pricing_disclaimer",
      last_updated_on: "@txt_12_last_updated",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "@txt_5_route_planner"
  },
  fuels: {
    adblue: "flag_fuel_adblue",
    auto_rv_propane: "flag_fuel_auto_rv_propane",
    autogas_lpg: "flag_fuel_autogas_lpg",
    cng: "flag_fuel_cng",
    diesel_fit: "flag_fuel_dieselfit",
    fuelsave_98: "flag_fuel_fuelsave_98",
    fuelsave_midgrade_gasoline: "flag_fuel_fuelsave_midgrade_gasoline",
    fuelsave_regular_diesel: "flag_fuel_fuelsave_regular_diesel",
    gtl: "flag_fuel_gtl",
    hydrogen: "flag_fuel_hydrogen",
    lng: "flag_fuel_lng",
    low_octane_gasoline: "flag_fuel_low_octane_gasoline",
    midgrade_gasoline: "flag_fuel_midgrade_gasoline",
    premium_diesel: "flag_fuel_premium_diesel",
    premium_gasoline: "flag_fuel_premium_gasoline",
    shell_regular_diesel: "flag_fuel_shell_regular_diesel",
    super98: "flag_fuel_super98",
    super_premium_gasoline: "flag_fuel_super_premium_gasoline",
    truck_diesel: "flag_fuel_truck_diesel",
    unleaded_super: "flag_fuel_unleaded_super",
    kerosene: "flag_fuel_kerosene",
    shell_recharge: "flag_fuel_recharge"
  },
  amenities: {
    air_and_water: "@txt_27_flag_airfill",
    atm_in: "@txt_27_flagatmin",
    atm_out: "@txt_27_flagatmout",
    atm: "@txt_27_flag_amenity_atm",
    austrian_highway_sticker: "@txt_27_flag_at_sticker",
    baby_change_facilities: "@txt_100_amenities_baby_change_facilities",
    bakery_shop: "@txt_100_amenities_bakery_shop",
    bank_note_acceptor: "@txt_27_flag_depositcash",
    bottled_gas: "@txt_27_flag_bottledgas",
    burger: "@txt_100_amenities_burger",
    cafe: "@txt_27_flag_cafeteria",
    carwash: "@txt_27_flag_amenity_carwash",
    children_play_area: "@txt_100_amenities_children_play_area",
    childs_toilet: "@txt_27_flag_childtoilet",
    clubsmart_card: "@txt_27_flag_clubsmart",
    coca_cola_freestyle: "@txt_100_amenities_coca_cola_freestyle",
    conveyor_and_jet: "@txt_100_amenities_conveyor_and_jet",
    conveyor: "@txt_100_amenities_conveyor",
    costa_express: "@txt_27_flag_costa",
    credit_card_american_express: "@txt_27_flag_amexcard",
    credit_card_diners_club: "@txt_27_flag_dinerscard",
    credit_card_general: "@txt_27_flag_ccardgeneral",
    credit_card_mastercard: "@txt_27_flag_mastercard",
    credit_card_visa: "@txt_27_flag_visacard",
    credit_card: "@txt_27_flag_ccard",
    czech_highway_sticker: "@txt_27_flag_cz_sticker",
    deli2go: "@txt_27_flag_deli3go",
    disability_assistance: "@txt_27_flag_disabilityassistance",
    disabled_facilities: "@txt_27_flag_disabledfacilities",
    euroshell_card: "@txt_27_flag_shellcard",
    fleet_card_dkv: "@txt_27_flag_fleetcard_dkv",
    fleet_card_eni: "@txt_27_flag_fleetcard_eni",
    fleet_card_esso: "@txt_27_flag_fleetcard_esso",
    fleet_card_general: "@txt_27_flag_fleetcard",
    fleet_card_uta: "@txt_27_flag_fleetcard_uta",
    food_offerings: "@txt_13_food_offerrings",
    fuel_card: "@txt_100_amenities_fuel_card",
    full_service: "@txt_27_flag_attended",
    guarded_car_park: "@txt_27_flag_guardedparking",
    hgv_lane: "@txt_27_flag_type_crts",
    high_speed_diesel_pump: "@txt_27_flag_highspeeddiesel",
    hot_food: "@txt_27_flag_hotfood",
    hungarian_highway_sticker: "@txt_27_flag_hu_sticker",
    ido_ticket: "@txt_27_flag_ido",
    jet: "@txt_100_amenities_jet",
    lottery: "@txt_100_amenities_lottery",
    loyalty_cards: "@txt_100_amenities_loyalty_cards",
    manual: "@txt_100_amenities_manual",
    maut_terminal: "@txt_27_flag_tollterminal",
    mobile_airtime: "@txt_100_amenities_mobile_airtime",
    mobile_payment: "@txt_27_flag_mobilepayments",
    money_transfer_services: "@txt_100_amenities_money_transfer_services",
    motorway_service: "@txt_100_amenities_motorway_service",
    navigator_fleet_loyalty_discount: "@txt_100_amenities_navigator_fleet_loyalty_discount",
    oil_and_lubricants: "@txt_100_amenities_oil_and_lubricants",
    others: "@txt_100_amenities_others",
    parking_lanes: "@txt_27_flag_parkinglanes",
    partner_card: "@txt_100_amenities_partner_card",
    partner_loyalty_accepted: "@txt_13_partner_loyalty_accepted",
    pay_at_pump: "@txt_27_flag_amenity_pay_at_pump",
    pizza: "@txt_100_amenities_pizza",
    prayer_room: "@txt_100_amenities_prayer_room",
    quick_lubes: "@txt_27_flag_quicklube",
    restaurant: "@txt_27_flag_restaurant",
    rollover_and_jet: "@txt_100_amenities_rollover_and_jet",
    rollover: "@txt_100_amenities_rollover",
    sandwich: "@txt_100_amenities_sandwich",
    sconti_bancoposta: "@txt_100_amenities_sconti_bancoposta",
    selectshop: "@text_100_amenities_select_shop",
    self_service: "@txt_27_flag_selfservice",
    service_bay: "@txt_27_flag_servicebay",
    shell_card: "@txt_27_flag_shellcard",
    shell_club_smart_extra_card: "@txt_27_flag_goldclubsmart",
    shop: "@txt_27_flag_hasShop",
    shower: "@txt_27_flag_shower",
    slovak_highway_sticker: "@txt_27_flag_sk_sticker",
    snack_food: "@txt_27_flag_food2go",
    standard_toilet: "@txt_27_flag_standardtoilet",
    starbucks: "@text_100_amenities_starbucks",
    supermarket_fuel_discount: "@txt_27_flag_fueldiscount",
    telepass_premium: "@txt_100_amenities_telepass_premium",
    tim_hortons: "@txt_27_flag_timhorton",
    toilet: "@txt_27_flag_amenity_toilet",
    truck_parking: "@txt_27_flag_hgvparking",
    truckport: "@txt_27_flag_type_crtm",
    twenty_four_hour: "@txt_27_flag_amenity_24hour",
    twotheloo: "@txt_27_flag_loo",
    tyre_service: "@txt_100_amenities_tyre_service",
    unmanned: "@txt_27_flag_unmanned",
    utility_payment_services: "@txt_100_amenities_utility_payment_services",
    vacuum: "@txt_27_flag_vacuum",
    vehicle_identity_system: "@txt_27_flag_videntity",
    waitrose: "@txt_27_flag_waitrose",
    wifi: "@txt_27_flag_wifi"
  },
  settings: {
    title: "@txt_8_settings",
    tooltip: "@txt_8_settings",
    traffic: "@txt_100_settings_traffic",
    distance_units: {
      title: "@txt_8_distance",
      km: "@txt_5_kilometers",
      miles: "@txt_5_miles"
    },
    language: {
      title: "@txt_8_language",
      locales: {
        es_AR: "@txt_100_settings_locales_es_AR",
        en_AU: "@txt_100_settings_locales_en_AU",
        de_AT: "@txt_100_settings_locales_de_AT",
        fr_BE: "@txt_100_settings_locales_fr_BE",
        nl_BE: "@txt_100_settings_locales_nl_BE",
        pt_BR: "@txt_100_settings_locales_pt_BR",
        en_BG: "@txt_100_settings_locales_en_BG",
        bg_BG: "@txt_100_settings_locales_bg_BG",
        fr_CA: "@txt_100_settings_locales_fr_CA",
        en_CA: "@txt_100_settings_locales_en_CA",
        cz_CZ: "@txt_100_settings_locales_cz_CZ",
        da_DK: "@txt_100_settings_locales_da_DK",
        fi_FI: "@txt_100_settings_locales_fi_FI",
        fr_FR: "@txt_100_settings_locales_fr_FR",
        de_DE: "@txt_100_settings_locales_de_DE",
        en_HK: "@txt_100_settings_locales_en_HK",
        zh_HK: "@txt_100_settings_locales_zh_HK",
        hu_HU: "@txt_100_settings_locales_hu_HU",
        en_IN: "@txt_100_settings_locales_en_IN",
        en_ID: "@txt_100_settings_locales_en_ID",
        id_ID: "@txt_100_settings_locales_id_ID",
        it_IT: "@txt_100_settings_locales_it_IT",
        lv_LV: "@txt_100_settings_locales_lv_LV",
        lt_LT: "@txt_100_settings_locales_lt_LT",
        fr_LU: "@txt_100_settings_locales_fr_LU",
        en_LU: "@txt_100_settings_locales_en_LU",
        en_MY: "@txt_100_settings_locales_en_MY",
        en_MO: "@txt_100_settings_locales_en_MO",
        zh_MO: "@txt_100_settings_locales_zh_MO",
        nl_NL: "@txt_100_settings_locales_nl_NL",
        nb_NO: "@txt_100_settings_locales_nb_NO",
        en_OM: "@txt_100_settings_locales_en_OM",
        ar_OM: "@txt_100_settings_locales_ar_OM",
        en_PK: "@txt_100_settings_locales_en_PK",
        ur_PK: "@txt_100_settings_locales_ur_PK",
        en_PH: "@txt_100_settings_locales_en_PH",
        pl_PL: "@txt_100_settings_locales_pl_PL",
        es_PR: "@txt_100_settings_locales_es_PR",
        ro_RO: "@txt_100_settings_locales_ro_RO",
        ru_RU: "@txt_100_settings_locales_ru_RU",
        en_SG: "@txt_100_settings_locales_en_SG",
        sk_SK: "@txt_100_settings_locales_sk_SK",
        sl_SI: "@txt_100_settings_locales_sl_SI",
        en_ZA: "@txt_100_settings_locales_en_ZA",
        sv_SE: "@txt_100_settings_locales_sv_SE",
        fr_CH: "@txt_100_settings_locales_fr_CH",
        de_CH: "@txt_100_settings_locales_de_CH",
        th_TH: "@txt_100_settings_locales_th_TH",
        tr_TR: "@txt_100_settings_locales_tr_TR",
        uk_UA: "@txt_100_settings_locales_uk_UA",
        en_GB: "@txt_100_settings_locales_en_GB",
        en_US: "@txt_100_settings_locales_en_US"
      }
    }
  },
  geolocation: {
    tooltip: "@txt_30_use_my_location"
  }
}
